import React, { useState, useEffect } from 'react';
import { fleetService } from '../services/fleetService';
import { employeeService } from '../services/employeeService';
import { toast } from 'react-toastify';
import BusMascot from '../components/BusMascot';

const Dispatch = () => {
  const [vehicles, setVehicles] = useState([]);
  const [drivers, setDrivers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const [vehiclesData, driversData] = await Promise.all([
        fleetService.getAll({ status: 'active' }),
        employeeService.getDrivers()
      ]);
      setVehicles(vehiclesData.vehicles || []);
      setDrivers(driversData.drivers || []);
    } catch (err) {
      toast.error('Failed to load dispatch data');
    } finally {
      setLoading(false);
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'active': return '#4CAF50';
      case 'en_route': return '#2196F3';
      case 'maintenance': return '#FF9800';
      default: return '#9E9E9E';
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <BusMascot size={80} animated />
        <p>Loading dispatch board...</p>
      </div>
    );
  }

  return (
    <div className="page-container dispatch-page">
      <div className="page-header">
        <h1>Dispatch Board</h1>
        <div className="header-stats">
          <span className="stat">
            <strong>{vehicles.length}</strong> Active Buses
          </span>
          <span className="stat">
            <strong>{drivers.length}</strong> Available Drivers
          </span>
        </div>
      </div>

      <div className="dispatch-grid">
        {/* Active Vehicles */}
        <div className="dispatch-section">
          <h2>Active Vehicles</h2>
          <div className="dispatch-cards">
            {vehicles.length === 0 ? (
              <div className="empty-state">
                <BusMascot size={60} />
                <p>No active vehicles</p>
              </div>
            ) : (
              vehicles.map(vehicle => (
                <div key={vehicle.id} className="dispatch-card">
                  <div className="card-header">
                    <BusMascot size={32} />
                    <h3>Bus #{vehicle.bus_number}</h3>
                    <span 
                      className="status-dot" 
                      style={{ backgroundColor: getStatusColor(vehicle.status) }}
                    />
                  </div>
                  <div className="card-body">
                    <p><strong>Driver:</strong> {vehicle.assigned_driver_name || 'Unassigned'}</p>
                    <p><strong>Capacity:</strong> {vehicle.capacity} seats</p>
                    <p><strong>Status:</strong> {vehicle.status}</p>
                  </div>
                  <div className="card-actions">
                    <button className="btn-small">Assign Route</button>
                    <button className="btn-small">Track</button>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>

        {/* Available Drivers */}
        <div className="dispatch-section">
          <h2>Available Drivers</h2>
          <div className="drivers-list">
            {drivers.length === 0 ? (
              <div className="empty-state">
                <p>No available drivers</p>
              </div>
            ) : (
              drivers.map(driver => (
                <div key={driver.id} className="driver-card">
                  <div className="driver-info">
                    <h4>{driver.name}</h4>
                    <span className="employee-id">{driver.employee_id}</span>
                  </div>
                  <div className="driver-status">
                    {driver.assigned_bus ? (
                      <span className="assigned">Bus #{driver.assigned_bus}</span>
                    ) : (
                      <span className="available">Available</span>
                    )}
                  </div>
                  <button className="btn-small">Assign</button>
                </div>
              ))
            )}
          </div>
        </div>
      </div>

      {/* Quick Actions */}
      <div className="quick-actions">
        <h2>Quick Actions</h2>
        <div className="action-buttons">
          <button className="action-btn">
            📍 Create Route
          </button>
          <button className="action-btn">
            📟 Send Alert
          </button>
          <button className="action-btn">
            📄 View Reports
          </button>
          <button className="action-btn">
            🔧 Maintenance
          </button>
        </div>
      </div>
    </div>
  );
};

export default Dispatch;
